var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _circle4, _circle5, _line, _line2, _line3, _line4, _path5, _path6, _path7, _path8, _path9, _path0, _circle6, _path1, _path10, _rect, _line5, _line6, _line7, _rect2, _rect3, _rect4, _circle7, _circle8, _path11, _path12, _path13, _path14, _path15, _path16, _rect5, _path17, _path18, _path19, _circle9, _path20, _path21, _circle0, _rect6, _path22, _path23, _rect7, _rect8, _rect9, _rect0, _rect1, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 263,
    viewBox: "0 0 441 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5258,
    cy: 141.103,
    r: 7.17037,
    fill: "#F58120"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.056,
    cy: 243.73,
    r: 6.22222,
    stroke: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.266,
    cy: 21.5633,
    r: 8.30741,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.345 217.737C233.345 223.925 228.329 228.941 222.141 228.941C215.954 228.941 210.938 223.925 210.938 217.737C210.938 211.549 215.954 206.533 222.141 206.533C228.329 206.533 233.345 211.549 233.345 217.737Z",
    fill: "#F58120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5129 226.303C81.5129 232.491 76.4968 237.507 70.3092 237.507C64.1215 237.507 59.1055 232.491 59.1055 226.303C59.1055 220.116 64.1215 215.1 70.3092 215.1C76.4968 215.1 81.5129 220.116 81.5129 226.303Z",
    fill: "#F58120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.593 10.8192C151.593 13.7893 149.186 16.197 146.216 16.197C143.246 16.197 140.838 13.7893 140.838 10.8192C140.838 7.84912 143.246 5.44141 146.216 5.44141C149.186 5.44141 151.593 7.84912 151.593 10.8192Z",
    fill: "#F58120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.439 257.622C137.439 260.592 135.031 263 132.061 263C129.091 263 126.684 260.592 126.684 257.622C126.684 254.652 129.091 252.245 132.061 252.245C135.031 252.245 137.439 254.652 137.439 257.622Z",
    fill: "#528FF5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.762,
    cy: 216.841,
    r: 11.6,
    stroke: "#333333",
    strokeDasharray: "5 5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.362,
    cy: 220.426,
    r: 6.51482,
    stroke: "#1098F7",
    strokeWidth: 4,
    strokeDasharray: "4 4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 265.611,
    y1: 212.601,
    x2: 300.567,
    y2: 212.601,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 279.965,
    y1: 238.592,
    x2: 314.92,
    y2: 238.592,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 279.965,
    y1: 221.563,
    x2: 334.639,
    y2: 221.563,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 279.965,
    y1: 229.629,
    x2: 334.639,
    y2: 229.629,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.724 166.687H74.2988C71.5374 166.687 69.2988 168.925 69.2988 171.687V176.975C69.2988 179.736 71.5374 181.975 74.2988 181.975H317.829C320.59 181.975 322.829 179.736 322.829 176.975V171.687C322.829 168.925 320.59 166.687 317.829 166.687H228.622C227.381 166.687 226.184 167.148 225.264 167.982L222.757 170.255C221.837 171.089 220.64 171.551 219.398 171.551H172.169C170.996 171.551 169.86 171.138 168.96 170.385L165.933 167.852C165.033 167.099 163.897 166.687 162.724 166.687Z",
    stroke: "#1E334E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.195 188.345L199.054 194.067H205.071L200.203 197.603L202.063 203.325L197.195 199.789L192.328 203.325L194.187 197.603L189.319 194.067H195.336L197.195 188.345Z",
    fill: "#1E334E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.389 188.345L179.248 194.067H185.264L180.397 197.603L182.256 203.325L177.389 199.789L172.521 203.325L174.38 197.603L169.513 194.067H175.529L177.389 188.345Z",
    fill: "#1E334E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.584 188.345L159.443 194.067H165.46L160.592 197.603L162.451 203.325L157.584 199.789L152.716 203.325L154.576 197.603L149.708 194.067H155.725L157.584 188.345Z",
    fill: "#1E334E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.428 188.345L141.287 194.067H147.303L142.436 197.603L144.295 203.325L139.428 199.789L134.56 203.325L136.419 197.603L131.552 194.067H137.568L139.428 188.345Z",
    fill: "#1E334E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M119.621 188.345L121.48 194.067H127.497L122.629 197.604L124.489 203.326L119.621 199.789L114.753 203.326L116.613 197.604L111.745 194.067H117.762L119.621 188.345Z",
    fill: "#1E334E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.9126,
    cy: 136.624,
    r: 6.67037,
    stroke: "#333333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2598 170.13H73.2598V171.13V173.372H75.2598V172.13H169.279L174.808 178.084L175.105 178.404H175.541H226.63H227.09L227.389 178.055L232.468 172.13H327.36V173.372H329.36V171.13V170.13H328.36H232.008H231.548L231.249 170.479L226.17 176.404H175.977L170.448 170.449L170.151 170.13H169.715H74.2598Z",
    fill: "#F58120"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6211 40.7173H266.951C226.169 57.2988 143.71 46.5432 128.921 71.1914C117.09 90.9099 99.7915 97.9309 92.6211 98.9766V44.7173C92.6211 42.5081 94.412 40.7173 96.6211 40.7173Z",
    fill: "#F58120"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90.459,
    y: 37.2549,
    width: 209.63,
    height: 128.963,
    rx: 6.5,
    stroke: "#1E334E"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 81.8848,
    y1: 68.2954,
    x2: 100.707,
    y2: 68.2954,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 89.959,
    y1: 79.9468,
    x2: 108.781,
    y2: 79.9468,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 81.8848,
    y1: 91.5996,
    x2: 100.707,
    y2: 91.5996,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 70.8074,
    height: 42.1259,
    rx: 5,
    fill: "#F58120"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19.8594,
    width: 70.8074,
    height: 9.85926,
    fill: "#FFEBDA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1055,
    y: 37.7847,
    width: 14.3407,
    height: 9.85926,
    rx: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 2.08519,
    transform: "matrix(-1 0 0 1 335.085 207.43)",
    stroke: "white",
    strokeWidth: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 2.08519,
    transform: "matrix(-1 0 0 1 349.417 207.431)",
    stroke: "white",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M298.564 56.6916L290.369 38.3682C309.403 29.856 304.525 48.2894 320.303 45.5355C332.924 43.3325 341.317 47.6097 344 50.7118C323.299 48.9756 305.043 53.7938 298.564 56.6916Z",
    fill: "#1E334E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M323.43 7.17335C310.265 24.5472 293.656 33.5596 286.441 36.197L296.87 59.5158C310.635 52.0695 330.802 51.3853 343.681 52.2719C346.828 52.4885 349.229 49.2562 347.941 46.3766L330.713 7.85531C329.412 4.94538 325.355 4.63268 323.43 7.17335Z",
    stroke: "#1E334E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M297.305 60.4927L303.474 74.2864C304.375 76.3031 306.741 77.2068 308.758 76.3049L310.759 75.4099C312.776 74.508 313.68 72.1421 312.778 70.1254L307.057 57.3343",
    stroke: "#1E334E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M286.443 36.1951C282.079 37.3473 272.744 43.9359 276.971 54.5162C278.759 58.9919 285.91 64.7997 296.872 59.5138",
    stroke: "#1E334E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M280.714 54.1034C277.287 45.6256 283.957 40.7053 287.133 39.9268L295.504 58.6451C287.599 62.4884 282.164 57.6898 280.714 54.1034Z",
    fill: "#F58120"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310.316 71.4206C310.654 72.1768 311.541 72.5157 312.297 72.1775C313.053 71.8393 313.392 70.9521 313.054 70.1958L310.316 71.4206ZM304.074 57.4644L310.316 71.4206L313.054 70.1958L306.813 56.2397L304.074 57.4644Z",
    fill: "#F58120"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4805,
    y: 120.048,
    width: 54.5704,
    height: 35.7482,
    rx: 0.5,
    stroke: "#1E334E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9846 154.677L91.7493 133.639L117.514 154.677H65.9846Z",
    stroke: "#1E334E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7621 140.271L70.2062 122.67L113.318 122.67L91.7621 140.271Z",
    fill: "white",
    stroke: "#1E334E",
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.093 122.98H71.0508L92.0721 139.543L113.093 122.98Z",
    fill: "#F58120",
    stroke: "#F58120",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.828,
    cy: 110.919,
    r: 43.6057,
    fill: "#528FF5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M242.434 110.919C242.434 118.339 240.54 125.637 236.932 132.121C233.324 138.606 228.121 144.062 221.815 147.974C215.509 151.886 208.309 154.123 200.897 154.475C193.484 154.827 186.105 153.282 179.457 149.985C172.809 146.689 167.112 141.75 162.905 135.637C158.699 129.524 156.122 122.438 155.419 115.051C154.716 107.664 155.909 100.219 158.887 93.4221C161.864 86.625 166.527 80.7002 172.434 76.2085L198.828 110.919H242.434Z",
    fill: "#F58120"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M234.021 137.042C229.613 143.094 223.73 147.918 216.931 151.054C210.133 154.191 202.645 155.536 195.18 154.962C187.715 154.388 180.521 151.914 174.282 147.774C168.043 143.635 162.966 137.969 159.536 131.314C156.105 124.659 154.433 117.237 154.68 109.754C154.927 102.271 157.084 94.9759 160.947 88.5619C164.809 82.1478 170.248 76.8285 176.746 73.1098C183.245 69.391 190.586 67.3966 198.073 67.316L198.545 111.202L234.021 137.042Z",
    fill: "#1E334E"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 111.5,
    r: 44,
    stroke: "#F58120"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 59.9482,
    height: 59.9482,
    rx: 3.5,
    transform: "matrix(-1 0 0 1 382.773 133.562)",
    stroke: "#1E334E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M326.398 187.603V144.286C342.111 144.286 348.845 159.005 354.233 169.099C358.542 177.173 368.898 184.799 373.537 187.603H326.398Z",
    fill: "#F58120"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M330.462 150.989C330.187 150.968 329.946 151.174 329.925 151.449C329.904 151.725 330.11 151.965 330.385 151.986L330.462 150.989ZM336.25 151.936L336.709 151.738L336.589 151.461L336.288 151.437L336.25 151.936ZM362.242 169.862L362.293 170.359L362.68 170.32L362.737 169.935L362.242 169.862ZM364.035 157.762L364.53 157.835L364.611 157.284L364.055 157.262L364.035 157.762ZM330.385 151.986L336.211 152.434L336.288 151.437L330.462 150.989L330.385 151.986ZM335.791 152.134L344.306 171.853L345.224 171.456L336.709 151.738L335.791 152.134ZM344.816 172.152L362.293 170.359L362.191 169.364L344.714 171.157L344.816 172.152ZM362.737 169.935L364.53 157.835L363.54 157.689L361.748 169.789L362.737 169.935ZM364.055 157.262L341.199 156.366L341.16 157.365L364.015 158.261L364.055 157.262ZM364.035 176.98H344.286V177.98H364.035V176.98ZM342.985 175.454C343.183 174.765 343.451 174.059 343.798 173.453C344.146 172.842 344.555 172.363 345.022 172.083L344.507 171.226C343.84 171.626 343.324 172.264 342.929 172.957C342.531 173.654 342.236 174.439 342.024 175.177L342.985 175.454ZM344.286 176.98C343.37 176.98 342.767 176.211 342.985 175.454L342.024 175.177C341.588 176.694 342.835 177.98 344.286 177.98V176.98Z",
    fill: "#1E334E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 363.219,
    y: 16.2437,
    width: 2.54804,
    height: 16.5623,
    transform: "rotate(68.5448 363.219 16.2437)",
    fill: "#F58120"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 365.438,
    y: 28.8525,
    width: 2.54804,
    height: 16.5623,
    transform: "rotate(95.2744 365.438 28.8525)",
    fill: "#F58120"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.54804,
    height: 16.5623,
    transform: "matrix(-0.840517 -0.541785 -0.541785 0.840517 355.293 6.52246)",
    fill: "#F58120"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 362.699,
    y: 39.3066,
    width: 2.54804,
    height: 16.5623,
    transform: "rotate(116.792 362.699 39.3066)",
    fill: "#F58120"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 2.54804,
    height: 16.5623,
    transform: "matrix(-0.980658 -0.195728 -0.195728 0.980658 345.131 1.56299)",
    fill: "#F58120"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9997 32.5C60.1664 9.16665 -4.10029 -17.2 1.49971 64C8.49971 165.5 65.5 249 159 239C252.5 229 320.5 51.4998 417.5 166.5C514.5 281.5 263.5 256.5 292.5 187.5C321.5 118.5 450 -24.5004 314 3.99978C292.833 11.8332 260 39.5 298 87.5",
    stroke: "#1E334E",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: "2 2 2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsImage);
export default __webpack_public_path__ + "static/media/about-us-image.e9a78ea997fd2cbea9c9c7e81f31e04c.svg";
export { ForwardRef as ReactComponent };